// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"d8913f60","78":"253e7c97","390":"fcb36547"}[chunkId] + ".css";
};